export const getColor=(i)=>{
    i=i+10
    return(`rgb( ${(((i-(i%6))/6)%6)*51},${((i-(i%36))/36)*51}, ${(i%(6))*51})`)
      }